import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Form, InputGroup, Button } from 'react-bootstrap';
import EvntHistoryModal from './modals/EventHistoryModal';
import { fetchEventHistory } from './Api';
import { FaTimes, FaSearch } from 'react-icons/fa';

function EvntHistory() {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState('');

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const data = await fetchEventHistory();
        setEvents(data);  // ← store full event object here
      } catch (error) {
        console.error("Error fetching event history:", error);
      }
    };

    loadEvents();
  }, []);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  return (
    <div
      className="p-4 w-100"
      style={{
        backgroundColor: '#ff9b45',
        color: '#FFECC8',
        minHeight: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.05)',
      }}
    >
      <h5 className="mb-4 fw-bold">Events History</h5>

      <div className="d-flex mb-3 gap-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search events..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <input
          type="date"
          className="form-control"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          style={{ maxWidth: 180 }}
        />
        <Button
          variant="outline-secondary"
          style={{
            border: '1px solid #FFECC8',
            color: '#FFECC8',
            backgroundColor: 'transparent',
            minWidth: 40,
          }}
          onClick={() => {
            setFilterDate('');
            setSearchTerm('');
          }}
        >
          <FaTimes size={18} />
        </Button>
      </div>

      <div
        className="table-responsive"
        style={{
          maxHeight: 'calc(10 * 2.5rem + 1rem)',
          overflowY: events.length > 10 ? 'auto' : 'visible',
        }}
      >
        <table className="table table-bordered table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Event</th>
              <th>Location</th>
              <th>Date Created</th>
            </tr>
          </thead>
          <tbody>
            {events
              .filter((event) =>
                event.event_name.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .filter((event) =>
                filterDate === '' || new Date(event.created_at).toISOString().slice(0, 10) === filterDate
              )
              .map((event, index) => (
                <tr
                  key={index}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleEventClick(event)}
                >
                  <td>{event.event_name}</td>
                  <td>{event.address}</td>
                  <td>{new Date(event.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <EvntHistoryModal show={showModal} onHide={handleCloseModal} eventData={selectedEvent} />
    </div>
  );
}

export default EvntHistory;
